module.exports = __webpack_public_path__ + "media/images/link_icon_w@2x-7b594ce0bdfe904650d1da21caee4b8e.png";